import { render } from "./list-data.vue?vue&type=template&id=28d7eeb8"
import script from "./list-data.vue?vue&type=script&lang=js"
export * from "./list-data.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__